import React from "react";
import { IStringLocalizer } from "../../../utilities/IStringLocalizer";
import { HelpfulSelection } from "./aiAnswerMetadata.types";

interface AIAnswerMetadataHelpfulActionsProps {
    localizer: IStringLocalizer;
    isDisabled: boolean;
    helpfulSelection: HelpfulSelection;
    onHelpfulClick: (selection: -1 | 1, event: React.MouseEvent<HTMLButtonElement>) => void;
}

const AIAnswerMetadataHelpfulActions: React.FC<AIAnswerMetadataHelpfulActionsProps> = ({
    localizer,
    isDisabled,
    helpfulSelection,
    onHelpfulClick
}) => (
    <div className="ai-answer-field__helpful-actions">
        <button
            type="button"
            className={helpfulSelection === 1
                ? "btn btn-xs ai-answer-field__helpful-button ai-answer-field__helpful-button--selected-up"
                : "btn btn-xs ai-answer-field__helpful-button"}
            title={localizer.localizeString("Helpful")}
            aria-disabled={isDisabled}
            disabled={isDisabled}
            onClick={(event) => onHelpfulClick(1, event)}
        >
            <span className="glyphicon glyphicon-thumbs-up" aria-hidden="true" />
        </button>
        <button
            type="button"
            className={helpfulSelection === -1
                ? "btn btn-xs ai-answer-field__helpful-button ai-answer-field__helpful-button--negative ai-answer-field__helpful-button--selected-down"
                : "btn btn-xs ai-answer-field__helpful-button ai-answer-field__helpful-button--negative"}
            title={localizer.localizeString("Not helpful")}
            aria-disabled={isDisabled}
            disabled={isDisabled}
            onClick={(event) => onHelpfulClick(-1, event)}
        >
            <span className="glyphicon glyphicon-thumbs-down" aria-hidden="true" />
        </button>
    </div>
);

export default AIAnswerMetadataHelpfulActions;
